<template>
<div id="purchased" class="purchased">
	<div class="location">
		<p>当前位置：</p>
		<p class="item" v-for="(item,index) in location" :key="index" @click="jumpPage(item)">{{item.title}} &gt;</p>
		已购课程
	</div>
    <div class="purchasedBox">
        <div class="titBox">
            <p class="tit">已购课程</p>
        </div>
		<ul class="list" v-loading="loading">
			<li v-for="(item,index) in purchased_list" :key="index">
				<span class="sch_type">{{course_type(item.course_type)}}</span>
				<p class="sch_tit">{{item.school}}</p>
				<p class="major">{{item.major}}<span class="major_level" v-if="item.major_level_text">{{item.major_level_text}}</span></p>
				<div class="money_time">
					<p class="open_time">开通日期：{{open_time_format(item.open_time)}}<span v-if="item.expire_time"> | 到期时间：{{open_time_format(item.expire_time)}}</span></p>
					<p class="money" v-if="item.virtual_price&&item.is_show">售价:￥<span>{{item.virtual_price}}</span></p>
				</div>
			</li>
		</ul>
    </div>
</div>
</template>

<script>
export default {
	data () {
		return {
			loading:true,
			purchased_list: [],
            location:[{
				title:"首页",
				router:"/web/" + this.$store.state.defaultIndex,
				name: this.$store.state.defaultIndex,
                query:{page: this.$store.state.defaultIndex}
			},{
				title:"个人信息",
				router:"/web/userIndex/",
				name: 'userIndex',
				query:{page:'userIndex'}
			}],
		}
	}
	,mounted:function(){
		this.get_purchased_course()
	}
	,methods:{
		//获取已购课程列表
		get_purchased_course(page){
			let token = this.$cookies.get("token")
			let url = this.global.serverSrc+this.global.qianzui+'/member/get_purchased_course';
			//发送修改密码请求
			this.$ajax.get(url).then(res => {
				let resData=res.data;
				this.loading = false
				if(resData.code==0){
					// 已购课程列表
					this.purchased_list = [...this.purchased_list, ...resData.data]
				}else if(resData.code==401){
					this.$message.error('请求错误');
				}else{
					this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
				}
			})/* .error(err => {
				this.loading = false
			}) */
		},
		// 课程类型输出
		course_type(type){
			let val = ''
			if(type == 1){
				val = '学历课程'
			}else if(type == 2){
				val = '职业培训'
			}
			return val;
		},
		// 开通日期格式输出
		open_time_format(time){
			// console.log(time);
			let val = '-'
			if(time != ''&&time){
				let timeArr = time.split(" ")
					,dayArr = timeArr[0].split("-")
				val = dayArr[0]+"年"+dayArr[1]+"月"+dayArr[2]+"日 "
				// val += timeArr[1]
			}
			return val
		},
        //点击当前位置的跳转函数
		jumpPage(args){
			this.$selfjs.jumpPage(this, args)
		},
	}
	,computed:{
		//根据身份隐藏内容
		hideType(){
			return parseInt(this.$store.state.hideType)
		},
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/userCenter/purchased.vue